import { Controller } from "stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    this.permissions = JSON.parse($("#permission-rows").attr("data-permissions")); // { "entity": ["list", "of", "actions"] }
  }

  entityChanged(e) {
    const row = e.currentTarget.closest(".permission-row");
    const selectedEntity = e.currentTarget.value;
    const actionSelect = row.querySelector(".action-selector");
    const actionSelectContainer = row.querySelector(".action-selector-container");

    if (selectedEntity && this.permissions[selectedEntity]) {
      let actionOptionsHtml = '<option value="">Select Actions</option>';
      this.permissions[selectedEntity].actions.forEach(action => {
        actionOptionsHtml += `<option value="${action}">${action}</option>`;
      });
      actionSelect.innerHTML = actionOptionsHtml;

      new TomSelect(actionSelect, {
        plugins: ['remove_button'],
        sortField: 'text',
        maxOptions: 10000,
      });

      actionSelectContainer.classList.remove("d-none");
    } else {
      actionSelect.innerHTML = "";
      actionSelectContainer.classList.add("d-none");
    }
  }

  showRestrictionSelect(e) {
    const row = e.currentTarget.closest(".permission-row");
    const entitySelect = row.querySelector(".entity-selector");
    const selectedEntity = entitySelect.value;
    
    if (!selectedEntity || !this.permissions[selectedEntity]) {
      alert("Please select an entity first.");
      return;
    }
    
    $.ajax({
      url: "/internal_tools/restrictions_selector",
      type: "GET",
      dataType: "script",
      data: {
        permission_index: row.getAttribute("data-index"),
        entity: selectedEntity
      }
    });
  }

  restrictionChanged(e) {
    const restrictionSelect = e.currentTarget;
    const selectedRestriction = restrictionSelect.value;
    if (!selectedRestriction) {
      restrictionSelect.parentNode.querySelector(".allowed-values-selector").remove();
      return;
    }
    
    const row = restrictionSelect.closest(".permission-row");
    const permissionIndex = row.getAttribute("data-index");
    const entitySelect = row.querySelector(".entity-selector");
    const selectedEntity = entitySelect.value;
    const restrictionSelectorIndex = restrictionSelect.closest(".single-restriction-container").getAttribute("data-index");
    
    $.ajax({
      url: "/internal_tools/restricted_collection",
      type: "GET",
      dataType: "script",
      data: {
        permission_index: permissionIndex,
        restriction: selectedRestriction,
        entity: selectedEntity,
        restriction_selector_index: restrictionSelectorIndex
      }
    });
  }

}
